import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../services';
import { Subject } from 'rxjs';
import { ManageService } from '../../../services/manage.service';
import { AssociateValidationResult } from '../../../models/csp.model';
import { FileService } from '../../../services/file.service';
import { AuthService } from '../../../services/auth.service';
import { takeUntil } from 'rxjs/operators';
import { CurrentUserModel } from '../../../models/account-ledger.model';

@Component({
  selector: 'app-bulk-associate',
  templateUrl: './bulk-associate.component.html',
  styleUrls: ['./bulk-associate.component.css']
})
export class BulkAssociateComponent implements OnInit, OnDestroy {

  setFullWindow = false;
  title = 'Bulk Associate';
  comparedValue = 'text';
  file: any;
  loadContent = true;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  public fileName: string;
  public currentUserModel: CurrentUserModel;

  public displayedColumns: string[] = [
    'tenantDescription',
    'tenantID',
    'email',
    'status'
  ];
  public resultTableDataSrc: AssociateValidationResult[] = [];
  purchaseAccess: boolean = false;
  adminAccess: boolean = false;
  tooltipUpload:string = "";
  disableUpload: boolean;

  constructor(
    private router: Router,
    private manageService: ManageService,
    private commonService: CommonService,
    private fileService: FileService,
    private authService: AuthService
  ) {
  }
  ngOnInit() {
    $('#levelOne').animate({ scrollLeft: 250 }, 400);

    this.authService.getLoginInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: CurrentUserModel) => {
          this.currentUserModel = res;

          if(!res.hasPurchaseAccess && res.hasAdminAccess) {
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Purchasing Permissions'
          }
          else if(res.hasPurchaseAccess && !res.hasAdminAccess) {
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Admin Permissions'
          } else if(!res.hasPurchaseAccess && !res.hasAdminAccess){
            this.disableUpload = true;
            this.tooltipUpload = 'Requires Admin and Purchasing Permissions'
          }
        },
        (error: any) => {
          console.info(error);
        }
      );

  }

  onSelectFile(event): void {
    this.loadContent = false;
    this.file = event.target.files[0];
    this.fileName = this.file?.name;
    this.resultTableDataSrc = [];
    this.loadContent = true;
  }

  onValidateDomains(): void {
    this.loadContent = false;
    const formData = new FormData();
    formData.append(this.file.name, this.file);
    this.manageService
      .validateBulkDomains(formData)
      .subscribe((res: AssociateValidationResult[]) => {
        this.loadContent = true;
        this.resultTableDataSrc = res;

        this.resultTableDataSrc.forEach((r) => {

          if (r.status == 'Validated') {
            r.statusColour = 'green'
          } else if (r.status.toLowerCase().includes('invalid')) {
            r.statusColour = 'red'
          }

        })

      }, (error: any) => {
        this.commonService.implementToast(error?.responseMessage, 'Error');
      });
  }

  checkStatusLink() {
    window.open("https://admin.microsoft.com/Adminportal/Home?invType=ResellerRelationship&partnerId=87dd1e14-7503-4c96-b552-2b4adc3f3bcc&msppId=0#/partners/invitation", "_blank");
  }

  drop(ev) {
    this.loadContent = false;

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      [...ev.dataTransfer.items].forEach((item, i) => {
        // If dropped items aren't files, reject them
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.file = file
          this.fileName = this.file.name;
          this.resultTableDataSrc = [];
        }
      });
    }
    this.loadContent = true;
  }

  public associateValidDomains() {
    this.loadContent = false;
    this.manageService
      .associateValidDomains(this.resultTableDataSrc)
      .subscribe((res: any) => {
        this.loadContent = true;

        this.resultTableDataSrc.forEach((r, i) => {

          if (res[i]?.status?.toLocaleLowerCase().includes('error') || res[i]?.status?.toLocaleLowerCase().includes('invalid')) {
            r.status = res[i]?.status
            r.statusColour = 'red'
          } else {
            r.status = 'Association Initiated'
            r.statusColour = 'green'
          }

        })
        // const success = this.resultTableDataSrc?.every(r => !r.status?.toLocaleLowerCase().includes('error'))
        // if (!success) {
        //   this.commonService.implementToast(JSON.stringify(this.resultTableDataSrc), 'Error');
        // } else {
        //   this.commonService.implementToast('Associate Successfully !', 'Success');
        // }
      }, (error: any) => {
        this.commonService.implementToast(error, 'Error');
      });
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  downloadSampleFile(): void {
    this.loadContent = false;
    this.fileService.saveFile('Bulk_Associate_CSP_Template.xlsx').subscribe(res => {
      this.fileService.saveAsExcelFile(res, 'Bulk_Associate_CSP_Template.xlsx');
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

  }
  downloadInstructionFile(): void {
    this.loadContent = false;
    this.fileService.saveFile('New Bulk Association Feature.pdf').subscribe(res => {
      this.fileService.saveAsExcelFile(res, 'New Bulk Association Feature.pdf');
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/CSP');
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
